import DropdownTemplateView from '../../../DropdownTemplateView'
import $ from 'jquery'
import {DropdownOptionsSelector} from '../../../customFields/components/DropdownOptionsSelector'

export default class DropdownOptionsMenu extends DropdownTemplateView {
    constructor({
        showMenuCb = () => {},
        hideMenuCb = () => {},
    }) {
        super()

        this.params = {
            showMenuCb,
            hideMenuCb,
        }

        this.state = {
            selectedOption: null,
            options: []
        }

        this.onStateChanged((state) => {
            this.selector.setState({
                ...state
            })
        })
    }

    templateHtml() {
        return "<div class='dropdownContainer components_dropdownOptionsMenu'</div>"
    }

    afterRender() {
        this.getEl().on('click', e => e.stopPropagation())
        this.selector = new DropdownOptionsSelector({
            onSelectCallback: this._handleOptionsSelected
        }).init(this.getEl())
    }

    showAt($element, positionParams, hideCallback) {
        super.showAt($element, positionParams)
        this.hideCallback = hideCallback
    }

    onShow() {
        super.onShow()
        this.params.showMenuCb()
    }

    onHide() {
        super.onHide()
        this.hideCallback(this.state.selectedOption)
        this.params.hideMenuCb()
    }

    remove() {
        this.getEl().remove()
    }

    mouseDownTargetElement() {
        return $('body')
    }

    _handleOptionsSelected = (selectedOption) => {
        this.setState({
            selectedOption
        })
        this.hide()
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/customFields/DropdownOptionsMenu.js